import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SalesFunnelDataService } from '../shared/sales-funnel-data.service';
import { ISalesFunnelLayoutChild } from '../shared/sales-funnel-child.module';

@Component({
  selector: 'app-order-confirmation',
  standalone: true,
  imports: [],
  templateUrl: './order-confirmation-component.html',
  styleUrls: ['./order-confirmation-component.scss']
})
export class OrderConfirmationComponent implements OnInit, ISalesFunnelLayoutChild {
  private router = inject(Router);
  private dataService = inject(SalesFunnelDataService);
  private now = new Date()

  orderReference = '';
  customerName = '';
  customerEmail = '';
  customerPhone = '';
  customerAddress = '';
  packageName = '';
  packageSpeed = '';
  packagePrice = '';
  submissionTime = `${this.now.toLocaleDateString()}, ${this.now.toLocaleTimeString()}`

  salesFunnelIndex = 4;

  constructor() {
    this.generateOrderReference();
    this.loadOrderDetails();
  }

  ngOnInit(): void {
    this.loadOrderDetails();
  }

  private generateOrderReference(): void {
    const prefix = 'TEL';
    const timestamp = Date.now().toString().slice(-6);
    const random = Math.floor(Math.random() * 10000)
      .toString()
      .padStart(4, '0');
    this.orderReference = `${prefix}-${timestamp}${random}`;
  }

  private loadOrderDetails(): void {
    const data = this.dataService.getData();

    if (data.customerDetails) {
      this.customerName = `${data.customerDetails.firstName} ${data.customerDetails.lastName}`.trim();
      this.customerEmail = data.customerDetails.email;
      this.customerPhone = data.customerDetails.phone;
    }

    this.customerAddress = '45 High Street, Upper Heyford, OX15 0SH';

    if (data.selectedPackage) {
      this.packageName = data.selectedPackage.name;
      this.packageSpeed = data.selectedPackage.speed < 0 ? 'Unlimited speed' : `${data.selectedPackage.speed} Mbps`;
      this.packagePrice = data.selectedPackage.price;
    }
  }

  copyReference(): void {
    navigator.clipboard.writeText(this.orderReference).then(() => {
      alert('Order reference copied to clipboard!');
    });
  }

  startNewOrder(): void {
    this.dataService.reset();
    this.router.navigate(['/sales-funnel']);
  }
}
